module.exports = __webpack_public_path__ + "static/media/bg-404lostPuppy.f0565f01.jpg";